module.exports = __webpack_public_path__ + "img/apiecobooster-demoday-2.1ad675e8.jpg";